import { render, staticRenderFns } from "./PlatformFeatureComparison.vue?vue&type=template&id=07c16798"
import script from "./PlatformFeatureComparison.vue?vue&type=script&lang=js"
export * from "./PlatformFeatureComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports